export const authTabs = {
  login: 'login',
  signUp: 'signUp',
} as const
export type AuthTab = keyof typeof authTabs
